import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toLower } from 'lodash';

import Select from 'rp-react-select';

import * as filterActions from '../actions';
import * as actionTypes from '../actions/filter';
import {
    multipleFields,
    multipleFieldsStudCountryCode
} from '../reducers/filter';
import * as filterConfig from '../optionSets/options';
import * as switcherConfig from '../optionSets/switchers';
import { bindAll, getRegisteredMethods } from '../utils/constructorHelper';
import { hasLocalData } from '../utils/localStorageHelper';
import { trackSearchClick } from '../utils/trackHelper';

import Button from '../components/Button';
import SelectBox from '../components/SelectBox';
import Switcher from './Switcher';
import FilterSection from '../components/FilterSection';
import Svg from 'rp-react-svg-icon';
import AdvanceSection from '../components/AdvanceSection';
import SecondarySection from '../components/SecondarySection';

const optionsQueryComparator = (optionLabel, query) =>
    toLower(optionLabel).startsWith(toLower(query));
const DEFAULT_PLACEHOLDER = 'Select..';

export class Filter extends PureComponent {
    constructor(props) {
        super(props);
        bindAll.call(this, getRegisteredMethods(Filter));
        this.selectOptionRowHeight = 48;
        this.getStallionRawData();
    }

    getStallionRawData() {
        this.props.fetchFilterData();
        this.props.fetchStallion(true);
    }

    searchStallions() {
        trackSearchClick();
        const { filter, stallion } = this.props;
        if (!stallion.isFetching && !filter.isFetching
            && (filter.touched || !stallion.data.length)) {
            this.props.fetchStallion();
        }
    }

    toggleFilter(name, value) {
        this.props.toggleFilter(
            actionTypes[name],
            value || filterConfig[name].defaultValue
        );
    }

    toggleStudFeeFilter(option) {
        let prices = ['', ''];
        if (option) {
            prices = option.split('/');
        }
        this.props.toggleFilter(actionTypes.MIN_PRICE, prices[0]);
        this.props.toggleFilter(actionTypes.MAX_PRICE, prices[1]);
    }

    toggleMainSwitcher(value) {
        const { filter, stallion } = this.props;
        if (!stallion.isFetching && !filter.isFetching) {
            this.props.updateFilterType(value);
            this.props.fetchFilterData();
        }
        if (!hasLocalData(`results-${value}`)) {
            this.props.fetchStallion(false, true);
        }
    }

    toggleSireLineFlag(value) {
        this.props.updateSireLineFlag(value);
        if (!value) {
            this.props.toggleFilter(
                actionTypes.SIRE_LINE,
                null
            );
        }
    }

    toggleAdvancedSection() {
        this.props.setAdvancedSectionVisibility(!this.props.isAdvancedSectionExpanded);
    }

    resetFilter() {
        const { filter, stallion } = this.props;

        if (!stallion.isFetching && !filter.isFetching) {
            this.props.updateFilterType('weatherbys');
            this.props.dropFilter();
            this.props.fetchFilterData();
        }
    }

    render() {
        const {
            rawData: {
                stallionNames,
                sireNames,
                sireLine: sireLines,
                studFarms
            },
            sireLineFlag,
            stallion,
            sire,
            sireType,
            sireLine,
            yearToStud,
            studFee,
            studFarm,
            distance,

            isAdvancedSectionExpanded,
        } = this.props.filter;
        const progenySuccess = Object.keys(multipleFields).filter(f => this.props.filter[f]);

        const countryCodes = Object.keys(multipleFieldsStudCountryCode)
            .filter(f => this.props.filter[f]);

        let arrowDirectionClassName = isAdvancedSectionExpanded ? 'arrow_display' : 'arrow_hide';

        const filterLocked = this.props.stallion.isFetching || this.props.filter.isFetching;
        const disabledClass = filterLocked ? 'disabled' : '';
        const sireLineDisabledClass = !sireLineFlag || filterLocked ?
            'disabled' : '';

        const containerClassName = 'sb-filter ';

        return (
            <div className={containerClassName}>
                <div className={'sections'} >
                    <div className={`sb-filter__selectBox ${disabledClass}`}>
                        <FilterSection
                            sectionName={`${this.props.mobileType ? '' : 'Filter Stallions'}`}
                        >
                            <Switcher
                                config={switcherConfig.STALLION}
                                onButtonClick={this.toggleMainSwitcher}
                                displayType="radio"
                            />
                            <SelectBox
                                selectTitle="Stallion Name"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Stallion Name'}
                                    rowHeight={this.selectOptionRowHeight}
                                    alphabet
                                    showSearch
                                    value={stallion}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={stallionNames}
                                    onChange={value => this.toggleFilter('STALLION', value)}
                                    optionsQueryComparator={optionsQueryComparator}
                                    dropdownListHeight={458}
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Country"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Country'}
                                    rowHeight={this.selectOptionRowHeight}
                                    value={countryCodes.length > 0 ? countryCodes : ['all']}
                                    optionsSorter={null}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={filterConfig.COUNTRY.options}
                                    onChange={
                                        value => this.toggleFilter('COUNTRY', value === 'all' ?
                                            [] :
                                            value
                                        )
                                    }
                                    multiSelect
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Stallion's Sire"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Stallion\'s Sire'}
                                    rowHeight={this.selectOptionRowHeight}
                                    alphabet
                                    showSearch
                                    value={sire}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={sireNames}
                                    onChange={value => this.toggleFilter('SIRE', value)}
                                    optionsQueryComparator={optionsQueryComparator}
                                    dropdownListHeight={458}
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Sire Type"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Sire Type'}
                                    rowHeight={this.selectOptionRowHeight}
                                    value={sireType}
                                    optionsSorter={null}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={filterConfig.SIRE_TYPE.options}
                                    onChange={value => this.toggleFilter('SIRE_TYPE', value)}
                                />
                            </SelectBox>
                        </FilterSection>

                        <div
                            onClick={this.toggleAdvancedSection}
                            className="sb-filter__header__advanced"
                        >
                            <span className={'sb-filter__header__advanced__label'}>
                                Advanced
                            </span>
                            <Svg
                                iconName={'downArrow'}
                                size="Small"
                                className={arrowDirectionClassName}
                            />
                        </div>
                    </div>
                    <AdvanceSection
                        isOpen={isAdvancedSectionExpanded && this.props.isOpen}
                        onClick={this.toggleAdvancedSection}
                    >
                        <SecondarySection sectionName={''}>
                            <div
                                className={
                                    `sb-filter__selectBox col-xs-12 ${disabledClass} }`
                                }
                            >
                                <label className={'sb-filter__selectBox__label'}>Sire Line</label>
                                <span className="sb-filter__disclaimer">
                                    Sire Line represents the paternal grandsire
                                    of their subject stallion
                                </span>

                                <Switcher
                                    config={switcherConfig.SIRE_LINE}
                                    onButtonClick={this.toggleSireLineFlag}
                                    displayType="box"
                                />
                            </div>

                            <SelectBox
                                selectTitle=""
                                disabledClass={sireLineDisabledClass}
                            >
                                <Select
                                    title={'Sire Line'}
                                    rowHeight={this.selectOptionRowHeight}
                                    alphabet
                                    showSearch
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    disabled={!sireLineFlag}
                                    value={sireLine}
                                    options={sireLines}
                                    onChange={value => this.toggleFilter('SIRE_LINE', value)}
                                    dropdownListHeight={458}
                                />
                            </SelectBox>
                        </SecondarySection>
                        <SecondarySection sectionName="Stud Criteria">
                            <SelectBox
                                selectTitle="Year to Stud"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Year to Stud'}
                                    rowHeight={this.selectOptionRowHeight}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    optionsSorter={null}
                                    value={yearToStud}
                                    options={filterConfig.YEAR_TO_STUD.options}
                                    onChange={value => this.toggleFilter('YEAR_TO_STUD', value)}
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Stud Farm"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Stud Farm'}
                                    rowHeight={this.selectOptionRowHeight}
                                    alphabet
                                    showSearch
                                    value={studFarm}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={studFarms}
                                    onChange={value => this.toggleFilter('STUD_FARM', value)}
                                    dropdownListHeight={458}
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Stud Fee"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Stud Fee'}
                                    rowHeight={this.selectOptionRowHeight}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    optionsSorter={null}
                                    value={studFee}
                                    options={filterConfig.STUD_FEE.options}
                                    onChange={value => this.toggleFilter('STUD_FEE', value)}
                                />
                            </SelectBox>
                        </SecondarySection>
                        <SecondarySection sectionName="Progeny Criteria">
                            <SelectBox
                                selectTitle="Progeny Win Distance"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Progeny Win Distance'}
                                    rowHeight={this.selectOptionRowHeight}
                                    value={distance}
                                    optionsSorter={null}
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={filterConfig.WIN_DIST.options}
                                    onChange={value => this.toggleFilter('WIN_DIST', value)}
                                />
                            </SelectBox>
                            <SelectBox
                                selectTitle="Progeny Success"
                                disabledClass={disabledClass}
                            >
                                <Select
                                    title={'Progeny Success'}
                                    rowHeight={this.selectOptionRowHeight}
                                    value={progenySuccess}
                                    optionsSorter={null}
                                    multiSelect
                                    placeholder={DEFAULT_PLACEHOLDER}
                                    options={filterConfig.PROGENY_SUCCESS.options}
                                    onChange={value => this.toggleFilter('PROGENY_SUCCESS', value)}
                                />
                            </SelectBox>
                        </SecondarySection>
                    </AdvanceSection>
                </div>

                <div className="sb-filter__footer">
                    <Button
                        className=" ui-btn ui-btn_large ui-btn_primary button-container_search"
                        disabled={filterLocked}
                        onClick={this.searchStallions}
                    >
                        APPLY
                    </Button>

                    <Button
                        className="ui-btn ui-btn_large ui-btn_secondary button-container_reset"
                        disabled={filterLocked}
                        onClick={() => {
                            this.resetFilter();
                        }
                        }
                    >
                        RESET
                    </Button>
                </div>
            </div>
        );
    }
}

Filter.propTypes = {
    stallion: PropTypes.object,
    filter: PropTypes.object,
    selects: PropTypes.object,
    fetchFilterData: PropTypes.func,
    fetchStallion: PropTypes.func,
    dropFilter: PropTypes.func,
    updateFilterType: PropTypes.func,
    updateSireLineFlag: PropTypes.func,
    toggleFilter: PropTypes.func,
    mobileType: PropTypes.string
};

function mapStateToProps(state) {
    return {
        filter: state.filter,
        stallion: state.stallion,
        selects: state.selects,
        isAdvancedSectionExpanded: state.filter.isAdvancedSectionExpanded,
    };
}

export default connect(mapStateToProps, filterActions)(Filter);



// WEBPACK FOOTER //
// ./src/client/containers/Filter.js